import React from 'react';
import moment from 'moment';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import { withStyles } from '@material-ui/core';

const styles = () => ({
    table: {
        maxWidth: '500px',
        margin: '0 auto'
    },
    subheading: {
        margin: '20px 0 10px'
    }
});

const TripsTable = ({ trips, classes }) => {
    if (!trips || !trips.length) {
        return (
            <>
                <p>
                    <strong>No trips taken</strong>
                </p>
                <p>We&apos;ll display all your trips here for your records</p>
            </>
        );
    }

    return (
        <TableContainer className={classes.table}>
            <Table aria-label="simple table">
                <TableHead>
                    <TableRow>
                        <TableCell>Date Time</TableCell>
                        <TableCell align="right">Service</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {trips.map(trip => (
                        <TableRow key={trip.date_time}>
                            <TableCell component="th" scope="row">
                                {moment(trip.date_time).format(
                                    'Do MMM YYYY HH:mm:ss'
                                )}
                            </TableCell>
                            <TableCell align="right">
                                {trip.service_name}
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default withStyles(styles)(TripsTable);
